import styles from "./Row.module.sass";
import cn from "classnames";
import { useNavigate } from "react-router-dom";
import Checkbox from "../../../../components/Checkbox";
import { getCenterById } from "../../../../services/center.service";

const Row = ({ item, selected, onSelect }) => {
    const navigate = useNavigate();

    // Combine address fields for display
    const fullAddress = `${item.address || ''}${item.address_complement ? ', ' + item.address_complement : ''}, ${item.zip_code || ''} ${item.city || ''}`;

    const handleRowClick = async () => {
        try {
            // Récupérer les données complètes du centre avant de naviguer
            const centerData = await getCenterById(item.id);
            navigate(`/admin/centers/${item.id}`, { state: { center: centerData } });
        } catch (error) {
            console.error('Erreur lors de la récupération des données du centre:', error);
            // Naviguer quand même avec les données partielles
            navigate(`/admin/centers/${item.id}`, { state: { center: item } });
        }
    };


    return (
        <>
            <div className={styles.row} style={{ cursor: 'pointer' }}>
                <div className={styles.col} onClick={(e) => e.stopPropagation()}>
                    <Checkbox
                        className={styles.checkbox}
                        value={selected}
                        checked={selected}
                        onChange={(e) => {
                            e.stopPropagation();
                            onSelect && onSelect(item.id);
                        }}
                    />
                </div>

                <div className={styles.col} onClick={handleRowClick}>
                    <div className={styles.item}>
                        <div className={styles.avatar}>
                            {/* You might want a default logo for centers, or a field in your collection */}
                            <img src={item.logoUrl || '/images/content/school_logo.png'} alt="Logo Centre" />
                        </div>
                        <div className={styles.details}>
                            <div className={styles.user}>{item.name}</div>
                            <div className={styles.login}>
                                {item.is_company_cfa ? (
                                    <span className={cn('status-type', 'status-blue')}>CFA d'entreprise</span>
                                ) : (
                                    <span className={cn('status-type', 'status-green')}>Centre de Formation</span>
                                )}
                            </div>
                            {item.main_cfa_location && (
                                <div className={styles.email}>
                                    <span className={cn('status-type', 'status-purple')}>Site Principal</span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className={styles.col} onClick={handleRowClick}>
                    <div className={styles.email}>{item.email}</div>
                    <div className={styles.email}>{item.phone}</div>
                </div>

                <div className={styles.col} onClick={handleRowClick}>
                    <div className={styles.address}>{fullAddress}</div>
                </div>

            </div>
        </>
    );
};

export default Row;